import React, { useEffect, useRef, useState } from "react";
import Item from "../../Item/Item";
import styles from "./SliderViewer.module.css";
import PropTypes from "prop-types";

const SliderViewer = ({ data }) => {
  const sliderRef = useRef(null);
  const [nonePointer, setNonePointer] = useState(false);

  /**
   * this useEffect is for handling scroll in X axis by click and draggingmouse in Desktop Devices.
   * also it will not openning the item url when we scroll and release the click.
   * All event Listeners will be clear when the component is unmounting.
   */
  useEffect(() => {
    const currentNode = sliderRef.current;
    let startX = null;
    let mouseDiff = 0;

    const mouseMoveEvent = (event) => {
      const currentX = event.screenX;
      currentNode.scrollTo(
        -1 * (currentX - startX) + currentNode.scrollLeft,
        0,
      );
      startX = currentX;
      if (++mouseDiff > 5) {
        setNonePointer(true);
      }
    };

    const mouseDownEvent = (event) => {
      startX = event.screenX;
      window.addEventListener("mousemove", mouseMoveEvent);
    };

    const mouseUpEvent = () => {
      setNonePointer(false);
      mouseDiff = 0;
      window.removeEventListener("mousemove", mouseMoveEvent);
    };

    currentNode.addEventListener("mousedown", mouseDownEvent);

    window.addEventListener("mouseup", mouseUpEvent);

    return () => {
      window.removeEventListener("mouseup", mouseUpEvent);
      window.removeEventListener("mousemove", mouseMoveEvent);
      currentNode.removeEventListener("mousedown", mouseDownEvent);
    };
  }, []);

  return (
    <div
      ref={sliderRef}
      className={`${styles.MainSlider} ${
        nonePointer ? styles.NonePointer : ""
      }`}
    >
      {data.map((product) => {
        return <Item key={product.id} data={product} />;
      })}
    </div>
  );
};

SliderViewer.propTypes = {
  data: PropTypes.object,
};

export default SliderViewer;
